import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/inspection.js";
import "@ui5/webcomponents-icons/dist/quality-issue.js";
import "@ui5/webcomponents-icons/dist/checklist-2.js";
import "@ui5/webcomponents-icons/dist/list.js";
import "@ui5/webcomponents-icons/dist/process.js";
import "@ui5/webcomponents-icons/dist/lab.js";
import "@ui5/webcomponents-icons/dist/document-text.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";

import { qualityPermissions, qualitySettingsGroup } from "./permissions";

/** Quality entries of the navigation registry (group `quality`, docs/contracts/quality.md). */
export const qualityNavigation: readonly NavigationEntry[] = [
  {
    key: "quality.lots",
    labelKey: "nav.qualityLots",
    icon: "inspection",
    path: "/quality/lots",
    permission: qualityPermissions.lotView,
  },
  {
    key: "quality.notifications",
    labelKey: "nav.qualityNotifications",
    icon: "quality-issue",
    path: "/quality/notifications",
    permission: qualityPermissions.notificationView,
  },
  {
    key: "quality.samplingPoints",
    labelKey: "nav.qualitySamplingPoints",
    icon: "lab",
    path: "/quality/sampling-points",
    permission: qualityPermissions.samplingPointView,
  },
  {
    key: "quality.policies",
    labelKey: "nav.qualityPolicies",
    icon: "document-text",
    path: "/quality/policies",
    permission: qualityPermissions.policyView,
  },
  {
    key: "quality.reports",
    labelKey: "nav.qualityReports",
    icon: "business-objects-experience",
    path: "/quality/reports",
    permission: qualityPermissions.lotView,
  },
  {
    key: "quality.plans",
    subGroup: "setup",
    labelKey: "nav.qualityPlans",
    icon: "checklist-2",
    path: "/quality/plans",
    permission: qualityPermissions.planView,
  },
  {
    key: "quality.codeSets",
    subGroup: "setup",
    labelKey: "nav.qualityCodeSets",
    icon: "list",
    path: "/quality/code-sets",
    permission: qualityPermissions.planView,
  },
  {
    key: "quality.triggers",
    subGroup: "setup",
    labelKey: "nav.qualityTriggers",
    icon: "process",
    path: "/quality/triggers",
    permission: qualityPermissions.triggerView,
  },
  {
    key: "quality.settings",
    subGroup: "setup",
    labelKey: "nav.qualitySettings",
    icon: "settings",
    path: `/platform/settings/${qualitySettingsGroup}`,
    permission: qualityPermissions.setupView,
  },
];
